<template>
<div>这是一个测试组件</div>
</template>

<script>
    export default {
        name: "Test"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Test/Test.vue